import { createContext, useContext, useEffect, useRef, useCallback } from 'react'
import signalRService from './signalRService'
import { LoadingContext } from 'src/M_Components'

const SignalRContext = createContext(null)

export const SignalRProvider = ({ children }) => {
  const ctx = useContext(LoadingContext)
  const activeGroups = useRef(new Set())
  const ctxRef = useRef(ctx)

  useEffect(() => {
      ctxRef.current = ctx
    }, [ctx])

  useEffect(() => {
    if (!localStorage.getItem("tokenMaeil")) return

    const init = async () => {
      await signalRService.start()

      signalRService.off("ReceiveTransportNotification")

      signalRService.on("ReceiveTransportNotification", (messageJson) => {
        try {
          const message = JSON.parse(messageJson)
          console.log("Notificação:", message)

          const toast = ctxRef.current?.toastMessages
          if (!toast) return

          if (message.IsSuccessful) {
            if (message.Type === "Warning") {
              ctx.toastMessages('warning', message.Message)
            } else {
              ctx.toastMessages('success', message.Message)
            }
          } else {
            ctx.toastMessages('error', message.Message)
          }
        } catch (error) {
          console.log("Erro ao processar notificação:", error)
        }
      })

      // Reconectar aos grupos após reconexão
      signalRService.connection?.onreconnected(() => {
        console.log("Reconnected, rejoining groups.")
        activeGroups.current.forEach(key => signalRService.joinGroup(key))
      })
    }

    init()

    return () => {
      signalRService.off("ReceiveTransportNotification")
    }
  }, [])

  const joinGroup = async (processKey) => {
    if (!processKey || activeGroups.current.has(processKey)) return
    
    await signalRService.joinGroup(processKey)
    activeGroups.current.add(processKey)
  }

  const leaveGroup = async (processKey) => {
    if (!processKey || !activeGroups.current.has(processKey)) return
    
    await signalRService.leaveGroup(processKey)
    activeGroups.current.delete(processKey)
  }

  return (
    <SignalRContext.Provider value={{ joinGroup, leaveGroup, activeGroups: activeGroups.current }}>
      {children}
    </SignalRContext.Provider>
  )
}

export const useSignalR = () => useContext(SignalRContext)
